import React from 'react';
import PropTypes from 'prop-types';

import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon, Translate } from '@hydra/common/components';
import Header from '@hydra/routes/pdf-editor/components/Header';
import EditorFormRow from '@hydra/routes/pdf-editor/components/EditorFormRow/EditorFormRow';
import EditorInline from '@hydra/routes/pdf-editor/components/EditorFormRow/EditorInline';
import FormToggle from '@hydra/routes/pdf-editor/components/FormToggle';
import ModulePanel from '@hydra/routes/pdf-editor/components/ModulePanel';
import InfoLabel from '@hydra/routes/pdf-editor/components/InfoLabel';

const useStyles = makeStyles(theme => ({
  pb: {
    paddingBottom: theme.spacing(4)
  }
}));

export const TabReview = ({
  template,
  modules,
  editing,
  editingValue,
  setEditingValue,
  setEditingField,
  resetEditing,
  saveFormField,
  headerLocked
}) => {
  const classes = useStyles();
  return (
    <>
      <Header title='pdf_editor_tab_review' hasLockedButton={headerLocked} />
      <Container
        {...template.applyCustomCriteria && { className: classes.pb }}
      >
        <EditorFormRow
          label={<Translate content='pdf_editor_add_review_content' />}
        >
          <EditorInline
            Component={FormToggle}
            field='reviewDataEnabled'
            value={template.reviewDataEnabled}
            otherFieldOpen={(editing !== null && editing !== 'reviewDataEnabled')}
            saveFormField={saveFormField}
          />
        </EditorFormRow>
        {
          template.reviewDataEnabled
            ? (
              <>
                <EditorFormRow
                  label={<Translate content='pdf_editor_manage_crit_content' />}
                  {...template.applyCustomCriteria && { noBorder: true }}
                >
                  <EditorInline
                    Component={FormToggle}
                    field='applyCustomCriteria'
                    value={template.applyCustomCriteria}
                    otherFieldOpen={(editing !== null && editing !== 'applyCustomCriteria')}
                    saveFormField={saveFormField}
                  />
                </EditorFormRow>
                {
                  template.applyCustomCriteria
                    ? (
                      <div>
                        {
                          modules
                            .filter(module => module.type !== 'serp')
                            .map(module => (
                              <ModulePanel
                                template={template}
                                key={module.type}
                                module={module}
                                editing={editing}
                                editingValue={editingValue}
                                setEditingValue={setEditingValue}
                                setEditingField={setEditingField}
                                resetEditing={resetEditing}
                                saveFormField={saveFormField}
                              />
                            ))
                        }
                      </div>
                      )
                    : (
                      <EditorFormRow infoLabel>
                        <InfoLabel style='default'>
                          <Icon type='information' style={{ marginRight: 8 }} />
                          <Translate content='pdf_editor_manage_crit_info' />
                        </InfoLabel>
                      </EditorFormRow>
                      )
                }
              </>
              )
            : (
              <EditorFormRow infoLabel>
                <InfoLabel style='default'>
                  <Icon type='information' style={{ marginRight: 8 }} />
                  <Translate content='pdf_editor_review_info' />
                </InfoLabel>
              </EditorFormRow>
              )
        }
      </Container>
    </>
  );
};

TabReview.propTypes = {
  template: PropTypes.shape({
    name: PropTypes.string
  }),
  modules: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      criteria: PropTypes.arrayOf(PropTypes.string)
    })
  )
};

export default TabReview;
